import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../utils/commonfunction";
import * as brandServices from "../../services/brand.services";
import { useTranslation } from "react-i18next";

const BrandView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("link_brand"), url: "/admin/brand/list/1" },
    { title: t("link_view"), url: "" },
  ];

  useEffect(() => {
    brandServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("heading_brand_view")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("list_heading_title")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.title ? showdefault.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_image")}</th>
                          <td><img src={showdefault && showdefault.image ? showdefault.image : ""} alt={showdefault?.title} style={{ height: "100px" }} /></td>
                        </tr>
                        <tr>
                          <th>{t("label_status")}</th>
                          <td>{showdefault && showdefault?.status !== undefined ? toHtml(showStatus(showdefault.status)) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandView;
